var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDefaultDoc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1437252873"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 91911",
    x: 0.428467,
    y: 0.0714111,
    width: 48,
    height: 48,
    rx: 4,
    fill: "#41C3D8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8567 25.4047H27.8567M19.8567 30.7381H30.5234M26.5234 12.0714H15.8567V36.0714H34.5234V20.0714M26.5234 12.0714H27.8567L34.5234 18.7381V20.0714M26.5234 12.0714V17.4047C26.5234 18.7381 27.8567 20.0714 29.19 20.0714H34.5234",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultDoc);
export default __webpack_public_path__ + "static/media/default-doc.dd3f8d79a8884d895d2845636075858a.svg";
export { ForwardRef as ReactComponent };